<template>
  <VTimePicker
    :model-value="timeLimit"
    :disabled="disabled"
    :class="[
      { compact: density === 'compact', 'text-error-600': isError },
      'h-100 d-block time-input'
    ]"
    variant="input"
    hide-title
    hide-header
    format="24hr"
    @update:model-value="onTimeUpdate"
  />
</template>

<script setup lang="ts">
type DensityType = 'compact' | 'default'

interface Props {
  timeLimit: string
  disabled?: boolean
  density?: DensityType
  isError?: boolean
}

interface Emits {
  (e: 'update:model-value', timeLimit: string): void
}

const { timeLimit, density = 'default' } = defineProps<Props>()
const emit = defineEmits<Emits>()

function onTimeUpdate(time: string | null): void {
  if (time) {
    emit('update:model-value', time)
  }
}
</script>

<style scoped lang="scss">
.time-input {
  min-width: 0 !important;
  min-height: 0 !important;

  :deep(div) {
    height: 100%;
  }

  :deep(.v-time-picker-controls__field-label) {
    display: none;
  }

  :deep(.v-time-picker-controls) {
    margin: 0;
    font-size: 100%;
  }

  :deep(.v-time-picker-controls__time) {
    width: 100%;
  }

  :deep(.v-time-picker-controls__time__separator) {
    font-size: 16px;
    line-height: 16px;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  :deep(.v-input) {
    height: 100% !important;
    width: unset;
    font-size: 100%;

    .v-field__overlay,
    .v-field {
      background-color: #fff;
      font-size: 100% !important;
    }

    .v-field__input {
      min-height: 0 !important;
    }
  }
}

.compact {
  :deep(.v-time-picker-controls__time__separator) {
    width: fit-content;
  }

  :deep(.v-input) {
    .v-field {
      width: fit-content;
    }

    .v-field__input {
      flex: unset;
      width: fit-content;
    }
  }
}
</style>
